import React from 'react'
import palette from 'src/designSystem/variables/palette'
import {
  MessageErrorIcon,
  MessageInfoIcon,
  MessageSuccessIcon,
  MessageWarningIcon,
} from './Message.styles'
import { MessageConfigType } from './Message.types'

export enum MessageType {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}

export const MessageConfig: Record<MessageType, MessageConfigType> = {
  [MessageType.INFO]: {
    icon: <MessageInfoIcon />,
    backgroundColor: '#E4F3FF',
    borderColor: '#2196F3',
  },
  [MessageType.WARNING]: {
    icon: <MessageWarningIcon />,
    backgroundColor: palette.orange[50],
    borderColor: palette.orange[600],
  },
  [MessageType.ERROR]: {
    icon: <MessageErrorIcon />,
    backgroundColor: palette.magenta[50],
    borderColor: palette.magenta[600],
  },
  [MessageType.SUCCESS]: {
    icon: <MessageSuccessIcon />,
    backgroundColor: palette.green[50],
    borderColor: palette.green[600],
  },
}
